<obg-m-dialog-layout
	[titleText]="title"
	[loading]="isBusy"
	[loadingMessage]="busyMessage"
	[navbar]="navbar"
	[navbarOptions]="navbarOptions"
	[hideClose]="hideClose"
	[hideFooter]="hideFooter"
>
	<ng-template #view></ng-template>
</obg-m-dialog-layout>
